<div
  *ngIf="showContent$ | async; else contentGuard"
  class="d-flex flex-column w-100 h-100"
>
  <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
  <ng-template [ngTemplateOutlet]="guardedContent"></ng-template>
</div>

<ng-template #contentGuard>
  <hs-panel-card [header]="contentGuardCardHeader">
    <p>{{ contentGuardCardMessage }}</p>
  </hs-panel-card>
</ng-template>
